<template>
  <div>
    <Header />
    <div class="adm-main-container">
      <slot />
    </div>
    <Footer />
  </div>
</template>

<script>
import ApiProgress from '../../plugins/ApiProgress';
import Header from '@components/navigation/Header';
import Footer from '@components/navigation/Footer';

export default {
  components: {
    Header,
    Footer,
  },
  mixins: [ApiProgress],
};
</script>
